export default function count(obj: Record<string, unknown>): number {
  return Object.keys(obj).length;
}
